import { render, staticRenderFns } from "./GoToExamButton.vue?vue&type=template&id=9ca3d872&scoped=true&"
import script from "./GoToExamButton.vue?vue&type=script&lang=js&"
export * from "./GoToExamButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca3d872",
  null
  
)

export default component.exports